/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OtResponse } from '../../models/ot-response';

export interface GetOts$Params {
  /**
   * idIntervenant
   */
  idIntervenant?: string;

  /**
   * statut
   */
  statut?: Array<
    | 'nouvelle'
    | 'genere'
    | 'analyse'
    | 'clos_valide'
    | 'clos_intervenant'
    | 'a_communiquer'
    | 'attribue'
    | 'annule'
    | 'a_faire'
  >;

  /**
   * weekBefore
   */
  weekBefore?: number;

  /**
   * weekAfter
   */
  weekAfter?: number;

  /**
   * planificationAvantDate
   */
  planificationAvantDate?: string;

  /**
   * planificationApresDate
   */
  planificationApresDate?: string;

  /**
   * idSite
   */
  idSite?: string;

  /**
   * team
   */
  team?: boolean;

  /**
   * limite
   */
  limite?: number;

  /**
   * realisationAvantDate
   */
  realisationAvantDate?: string;

  /**
   * realisationApresDate
   */
  realisationApresDate?: string;

  /**
   * sortField
   */
  sortField?: 'PrevisionDateDebut' | 'PlanDateFin' | 'DateModification';

  /**
   * sortOrder
   */
  sortOrder?: string;
}

export function getOts(
  http: HttpClient,
  rootUrl: string,
  params?: GetOts$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<OtResponse>>> {
  const rb = new RequestBuilder(rootUrl, getOts.PATH, 'get');
  if (params) {
    rb.query('idIntervenant', params.idIntervenant, {});
    rb.query('statut', params.statut, {});
    rb.query('weekBefore', params.weekBefore, {});
    rb.query('weekAfter', params.weekAfter, {});
    rb.query('planificationAvantDate', params.planificationAvantDate, {});
    rb.query('planificationApresDate', params.planificationApresDate, {});
    rb.query('idSite', params.idSite, {});
    rb.query('team', params.team, {});
    rb.query('limite', params.limite, {});
    rb.query('realisationAvantDate', params.realisationAvantDate, {});
    rb.query('realisationApresDate', params.realisationApresDate, {});
    rb.query('sortField', params.sortField, {});
    rb.query('sortOrder', params.sortOrder, {});
  }

  return http.request(rb.build({ responseType: 'blob', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OtResponse>>;
    })
  );
}

getOts.PATH = '/v2/ots';
